<template>
  <modal title="Post Notes" ref="modal">
    <post-notes :post-id="post.id" class="q-mb-md" />
    <post :post="post" />
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { Post as PostType } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import PostNotes from './PostNotes.vue';
import Post from '../card/Post.vue';

export default defineComponent({
  mixins: [ModalMixin],
  components: {
    Modal,
    Post,
    PostNotes,
  },
  props: {
    post: {
      type: Object as () => PostType,
      required: true,
    },
  },
});
</script>
